import React from "react";

import { Typography } from "@mui/material";

import { NextButton } from "../../common/NextButton";
import { QuestionDefinitionDto } from "./questionaire-types";

type QuestionaireBasePageProps = {
  questionDefinition: QuestionDefinitionDto;
  children: React.ReactNode;
  formik: any;
  isSaving: boolean;
  isFrenchLanguage:boolean;
};

export const QuestionaireBasePage = ({ questionDefinition, children, formik, isSaving,isFrenchLanguage }: QuestionaireBasePageProps) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      <Typography variant="h5" gutterBottom>
        {questionDefinition.title}
      </Typography>
      <Typography variant="subtitle1" gutterBottom component="div" dangerouslySetInnerHTML={{ __html: questionDefinition.text }} />
      {children}
      <NextButton loading={isSaving} isFrenchLanguage={isFrenchLanguage} sx={{ float: "right", marginTop: 3 }} />
    </form>
  );
};
